import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { LockButton, LockedTitle } from './styles';
import { useTranslation } from 'react-i18next';

export default function LockedData() {
  const { t } = useTranslation();
  return <LockedTitle>{t('locked')}</LockedTitle>;
}
